import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authService } from 'pages/auth/authService';
import { dashboardRoutes } from 'routes';

export const useLoginMutation = () => {
  const navigate = useNavigate();

  return useMutation(authService.login, {
    onSuccess: (res) => {
      authService.saveTokenToStorageAndQuery(res);
      navigate(dashboardRoutes.root, { replace: true });
    },
  });
};
